import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    AvatarComponent,
    ButtonComponent,
    DrawerItemComponent,
    DrawerMenuComponent,
    IconComponent
} from '@bilancio/ui';
import { JoyrideModule } from 'ngx-joyride';
import { NgxPermissionsModule } from 'ngx-permissions';
import { UserContextMenuComponent } from './user-context-menu.component';

@NgModule({
    declarations: [UserContextMenuComponent],
    exports: [UserContextMenuComponent],
    imports: [
        AvatarComponent,
        ButtonComponent,
        CommonModule,
        DrawerMenuComponent,
        DrawerItemComponent,
        IconComponent,
        JoyrideModule.forChild(),
        NgxPermissionsModule
    ]
})
export class UserContextMenuModule {}
